<template>
    <footer class="footer footer-static footer-light navbar-border">
        <div>
            <center>
            © 2022 made with <i class="icon-heart3"></i> by <a>Modern-Expo IT TEAM</a>
            </center>
        </div>
    </footer>
</template>

<script>
    export default {
        name: "Footer",
        components: {},
        data() {
            return {}
        },
        mounted() {
        },
        created() {
        },
        methods: {
        }
    };
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue